import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Divider,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from "@mui/material/IconButton";

const data = [
  { id: 1, label: '1.the ball is in the court ,2. the the ball is in the other court' },
  { id: 2, label: '1.the ball is in the court ,2. the the ball is in the other court' },
  { id: 3, label: '1.the ball is in the court ,2. the the ball is in the other court' },
];

 function PromptsPopUp({open, handleClose}) {
 
  const [inputValue, setInputValue] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const [finalPrompt, setFinalPrompt] = useState('');
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);


  // Enable button if input is not empty
//   useEffect(() => {
//     setIsButtonEnabled(inputValue.trim().length > 0);
//   }, [inputValue]);

  // When radio is selected, update input field
  const handleRadioChange = (event) => {
    const selectedId = parseInt(event.target.value, 10);
    const selected = data.find((item) => item.id === selectedId);
    if (selected) {
      setSelectedOption(selectedId);
      setInputValue(selected.label);
    }
  };

  // On "Import Prompt" click
  const handleImport = () => {
    setFinalPrompt(inputValue);
    console.log('Final Prompt:', inputValue);
    handleClose();
  };

  return (
    <>
 
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle
        sx={{
                        //   fontWeight: "bold",
                        fontSize: "16px",
                        paddingBottom: "10px",
                        fontFamily: "Roboto, sans-serif",
                        marginBottom: '10px'
                    }}
                >
                    Prompt Selection
                    <IconButton
                                onClick={handleClose} // Close dialog when clicked
                                sx={{
                                  position: "absolute", // Position the close button absolutely
                                  top: "8px", // Adjust distance from top
                                  right: "8px", // Adjust distance from right
                                }}
                              >
                                <CloseIcon />
                              </IconButton>

        </DialogTitle>
        <DialogContent>
          <Box display="flex" gap={2} py={3}>
            {/* Left - Input Field */}
            <Box flex={1}>
              <TextField
               label="Your Input"
               fullWidth
               multiline
               minRows={8}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </Box>

            {/* Divider */}
            <Divider orientation="vertical" flexItem  sx={{ height: 250 }}  />

            {/* Right - Radio Buttons */}
            <Box flex={1}>
              <RadioGroup value={selectedOption} onChange={handleRadioChange}>
                {data.map((item) => (
                  <FormControlLabel
                    key={item.id}
                    value={item.id.toString()}
                    control={<Radio />}
                    label={item.label}
                  />
                ))}
              </RadioGroup>
            </Box>
          </Box>
        </DialogContent>

        {/* Bottom - Import Button */}
        <DialogActions>
            <Box sx={{mb: 2}}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleImport}
            sx={{
                mb: 1,
                mr: 1.5,
            }}  
            disabled={!inputValue.trim()}
          >
            Import Prompt
          </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default PromptsPopUp;
 